import React from "react";
import Icon from "@ant-design/icons";

const DeleteOutlineSvg = ({
	width = "1rem",
	height = "1rem",
	fill = "none",
	stroke = "#667085",
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox={`0 0 ${width} ${height}`}
		height={height}
		width={width}
		fill={fill}
	>
		<path
			d="M5.83301 17.5C5.37467 17.5 4.98217 17.3367 4.65551 17.01C4.32884 16.6833 4.16579 16.2911 4.16634 15.8333V5H3.33301V3.33333H7.49967V2.5H12.4997V3.33333H16.6663V5H15.833V15.8333C15.833 16.2917 15.6697 16.6842 15.343 17.0108C15.0163 17.3375 14.6241 17.5006 14.1663 17.5H5.83301ZM14.1663 5H5.83301V15.8333H14.1663V5ZM7.49967 14.1667H9.16634V6.66667H7.49967V14.1667ZM10.833 14.1667H12.4997V6.66667H10.833V14.1667Z"
			fill="#344054"
		/>
	</svg>
);
const DeleteOutlineIcon = (props) => (
	<Icon component={() => <DeleteOutlineSvg {...props} />} />
);

export default DeleteOutlineIcon;
